// @ts-check
import React from 'react';

/**
 * @typedef {"manual" | "best-selling" | "title-ascending" | "title-descending" | "price-ascending" | "price-descending" | "created-ascending" | "created-descending"} SortOption
 */

/**
 * @typedef {["manual", "Featured"] | ["best-selling", "Best selling"] | ["title-ascending", "Alphabetically, A-Z"] | ["title-descending", "Alphabetically, Z-A"] | ["price-ascending", "Price, low to high"] | ["price-descending", "Price, high to low"] | ["created-ascending", "Date, old to new"] | ["created-descending", "Date, new to old"]} Option
 * An array where the first element is the value of the option and the second element is the description of the option.
 */

/**
 * Sort component for product grids
 * @component
 * @param {Object} props
 * @param {SortOption} props.default - The default sort option set in Admin settings.
 * @param {SortOption | null} props.current - The current sort option.
 * @param {Option[]} props.options - The page number of the current page.
 * @param {(event: Event) => void} props.onChange - The function to call when the sort option changes.
 * @returns {JSX.Element} The rendered button component.
 */

const Sort = ({ default: defaultOption, current: currentOption, options, onChange }) => {
  // @ts-ignore
  const facetLocales = window.TMW.Strings.collection.facets;

  return (
    <div className="flex items-center gap-1">
      <label
        className="body-1-bold whitespace-nowrap"
        htmlFor="sortBy"
      >
        {facetLocales.sortBy}
      </label>
      <select
        className="body-1-bold sort-select cursor-pointer border-transparent bg-[right_0_center] p-0 pr-6"
        name="sort_by"
        id="sortBy"
        onChange={onChange}
      >
        {options.map(([value, label]) => (
          <option
            key={value}
            value={value}
            selected={defaultOption === value || currentOption === value}
          >
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Sort;
